export const ENTITY_DRAWER_VIEW_ALL_ROUTE = 'mapCounts';
export const ENTITY_EDIT_ROUTE = 'counts/site';
